import { useMemo, useState } from "react";

const PINK = "#EE2677";

export const TS_DEPARTMENT_LABELS = {
  kitchen: "Kitchen",
  driver: "Delivery",
  inventory: "Inventory",
  chat: "Chat Report",
  we: "Work Ethic",
};

/**
 * Multi-select department chips for TS onboarding.
 * When 2+ departments are available, staff must pick at least 2 (no upper cap).
 */
export default function TsDepartmentPicker({
  availableDepartments = [],
  initialSelected = [],
  minRequired = 2,
  onConfirm,
  busy = false,
}) {
  const [selected, setSelected] = useState(() => [...initialSelected]);

  const canConfirm = useMemo(() => {
    if (availableDepartments.length <= 1) return selected.length >= 1;
    return selected.length >= minRequired;
  }, [availableDepartments.length, minRequired, selected.length]);

  const toggle = (key) => {
    setSelected((prev) => {
      if (prev.includes(key)) return prev.filter((k) => k !== key);
      return [...prev, key];
    });
  };

  return (
    <div className="ts-dept-picker">
      <style>{`
        .ts-dept-picker { margin-top: 4px; }
        .ts-dept-picker-hint {
          font-size: 13px; font-weight: 600; color: rgba(45,45,45,0.6);
          margin: 0 0 12px; line-height: 1.45;
        }
        .ts-dept-picker-chips { display: flex; flex-wrap: wrap; gap: 8px; }
        .ts-dept-chip {
          border: 2px solid #E5E7EB; border-radius: 999px; padding: 10px 14px;
          font-size: 14px; font-weight: 800; background: #fff; color: #2D2D2D;
          cursor: pointer;
        }
        .ts-dept-chip-on {
          border-color: ${PINK}; background: #FFF0F6; color: ${PINK};
        }
        .ts-dept-picker-primary {
          width: 100%; border: none; border-radius: 16px; padding: 16px;
          font-size: 17px; font-weight: 800; color: #fff; background: ${PINK};
          cursor: pointer; margin-top: 16px;
        }
        .ts-dept-picker-primary:disabled { opacity: 0.55; cursor: wait; }
      `}</style>

      <p className="ts-dept-picker-hint">
        {availableDepartments.length <= 1
          ? "Your department is set automatically."
          : `Pick at least ${minRequired} departments you will use on this device.`}
      </p>

      <div className="ts-dept-picker-chips">
        {availableDepartments.map((key) => {
          const on = selected.includes(key);
          return (
            <button
              key={key}
              type="button"
              className={`ts-dept-chip${on ? " ts-dept-chip-on" : ""}`}
              onClick={() => toggle(key)}
            >
              {TS_DEPARTMENT_LABELS[key] || key}
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className="ts-dept-picker-primary"
        disabled={!canConfirm || busy}
        onClick={() => onConfirm?.(selected)}
      >
        {busy ? "Saving…" : "Continue"}
      </button>
    </div>
  );
}
